export default __webpack_public_path__ + "static/media/references.4dbd7a36.svg";